import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { ConvenienceTest } from '@repo/user-types'

const initialState: GenericOperationState<ConvenienceTest[]> = {
  payload: [],
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: convenienceTestsDataActions, reducer: convenienceTestsDataReducer } =
  createOperationSlice<
    ConvenienceTest[],
    SliceCaseReducers<GenericOperationState<ConvenienceTest[]>>
  >({
    name: '@users/convenienceTests',
    initialState,
    reducers: {},
  })
